import React from 'react';
import {    
  safeFormatDate, 
  formatDateToDayId,
} from '../shared/utils';

export default function DateTimeTest() {
  // Test date strings
  const testDates = [
    '2025-05-12T20:24:34.488Z',
    '2025-08-08T18:15:00.000Z',
    '2025-08-21T19:10:00.000Z',
    '2025-08-11T11:00:00.000Z',
    '2025-08-10T18:30:00.000Z',
    '2025-08-10T21:30:00.000Z'
  ];

  // Using "2025-08-10" as target date for normalizeDate function
  const targetDate = '2025-08-10T00:00:00.000Z';
  
  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: '30px'
  };
  
  const headerStyle = {
    backgroundColor: '#f2f2f2',
    padding: '12px',
    textAlign: 'left',
    border: '1px solid #ddd'
  };
  
  const cellStyle = {
    padding: '8px',
    border: '1px solid #ddd'
  };
  
  const functionHeaderStyle = {
    backgroundColor: '#e0f7fa',
    padding: '10px',
    marginTop: '20px',
    marginBottom: '10px',
    borderRadius: '5px'
  };

  return (
    <div style={{ margin: '20px', fontFamily: 'Arial' }}>
      <h1>Date Functions Test Results</h1>
      
      <div style={functionHeaderStyle}>
        <h2>extractTimeFromISOString</h2>
      </div>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={headerStyle}>Input</th>
            <th style={headerStyle}>Result</th>
          </tr>
        </thead>
        <tbody>
          {testDates.map((date, index) => (
            <tr key={`time-${index}`}>
              <td style={cellStyle}>{date}</td>
              <td style={cellStyle}>{safeFormatDate(date,'time')}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <div style={functionHeaderStyle}>
        <h2>extractDateFromISOString</h2>
      </div>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={headerStyle}>Input</th>
            <th style={headerStyle}>Result</th>
          </tr>
        </thead>
        <tbody>
          {testDates.map((date, index) => (
            <tr key={`date-${index}`}>
              <td style={cellStyle}>{date}</td>
              <td style={cellStyle}>{safeFormatDate(date,'date')}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <div style={functionHeaderStyle}>
        <h2>safeFormatDate</h2>
      </div>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={headerStyle}>Input</th>
            <th style={headerStyle}>Default Format</th>
            <th style={headerStyle}>Format: yyyy-MM-dd</th>
            <th style={headerStyle}>Format: HH:mm</th>
          </tr>
        </thead>
        <tbody>
          {testDates.map((date, index) => (
            <tr key={`safe-${index}`}>
              <td style={cellStyle}>{date}</td>
              <td style={cellStyle}>{safeFormatDate(date)}</td>
              <td style={cellStyle}>{safeFormatDate(date, 'yyyy-MM-dd')}</td>
              <td style={cellStyle}>{safeFormatDate(date, 'HH:mm')}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <div style={functionHeaderStyle}>
        <h2>formatDateToDayId</h2>
      </div>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={headerStyle}>Input</th>
            <th style={headerStyle}>Result</th>
          </tr>
        </thead>
        <tbody>
          {testDates.map((date, index) => (
            <tr key={`day-${index}`}>
              <td style={cellStyle}>{date}</td>
              <td style={cellStyle}>{formatDateToDayId(new Date(date))}</td>
            </tr>
          ))}
        </tbody>
      </table>     
     
    </div>
  );
} 